import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from 'components/ui/button';
import { ModalConfirmation } from '../../popup/modalConfirmation';
import { useDispatch, useSelector } from 'react-redux';
import { feedbackSessionFormInFocus } from '../../../actions/feedbackFormInFocusAction';
import { RootState } from '../../../reducers';
import { questionField } from './SessionQuestion';
import { feedbackSessionQuestion } from '../../../actions/feedbackQuestionAction';
import { resetSessionFeedbackForm } from '../../../actions/feedbackAnswerAction';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const sessionFeedbackAnswerSchema = yup.object({
	feedback: yup.array().of(
		yup.object({
			question_id: yup.number(),
			question_category: yup.string(),
			required: yup.bool(),
			text: yup.mixed().when(['required', 'question_category'], ([required, category]) => {
				if (required && category !== 'stars') {
					return yup.lazy((value) =>
					Array.isArray(value)
						? yup.array().of(yup.string().trim()).required('This field is required')
						: yup.string().trim().required('This field is required')
					);
				}
				return yup.mixed().nullable().default(null);
			}),
			value: yup.number().when(['required', 'question_category'], ([required, category]) => {
				return required && category === 'stars'
					? yup.number().typeError('This field is required')
					: yup.number().nullable().default(null);
			}),
		})
	),
});

export default function SessionFeedbackForm({ onSubmit }: any) {
	const programQuestion = useSelector((state: RootState) => state.programQuestion);
	const programAnswer = useSelector((state: RootState) => state.programAnswer);
	const dispatch = useDispatch();
	const [displayModalConfirmation, setDisplayModalConfirmation] = useState(false);
	const optionStore = { action: 'leavingPage' };
	const { control, handleSubmit, formState: { errors } } = useForm<any>({ resolver: yupResolver(sessionFeedbackAnswerSchema) });
	const navigate = useNavigate();
	const onError = (formErrors: any) => console.log('errors: ', formErrors);
	const routeToFeedbackSessionPage = () => {
		dispatch(feedbackSessionFormInFocus(null));
		dispatch(feedbackSessionQuestion([]));
		dispatch(resetSessionFeedbackForm());
		navigate('../feedback-session');
	};
	const continueFeedback = handleSubmit(onSubmit, onError);

	return (
		<div className="mx-auto w-full">
			<header className="flex items-center gap-3 border-b border-gray-200 px-4 pb-5 pt-6 md:px-[22px]">
				<div className="min-w-0 flex-1 text-base font-bold leading-[23px] text-[#222222] md:leading-[37px]">Feedback</div>
				<Button className="hidden md:inline-flex" onClick={continueFeedback}>Continue</Button>
				<button aria-label="Cancel feedback" className="shrink-0 p-2 text-right" onClick={() => setDisplayModalConfirmation(!displayModalConfirmation)} type="button">
					<X className="ml-auto size-6" />
				</button>
			</header>
			<div className="h-[calc(100dvh-147px)] min-w-0 overflow-y-auto px-4 py-6 md:h-[calc(100dvh-160px)] md:px-[22px]">
				{questionField(programQuestion, control, errors, programAnswer)}
				<Button className="mt-6 w-full md:hidden" onClick={continueFeedback}>Continue</Button>
			</div>
			{displayModalConfirmation && (
				<ModalConfirmation
					callBackProceedMethodProp={routeToFeedbackSessionPage}
					displayModalConfirmation={displayModalConfirmation}
					optionStore={optionStore}
					setDisplayModalConfirmation={setDisplayModalConfirmation}
				/>
			)}
		</div>
	);
}
